import { requireNativeModule } from 'expo-modules-core';

// Native module will be implemented in subsequent stories
const LoqaAudioDspModule = requireNativeModule('LoqaAudioDsp');

export default LoqaAudioDspModule;
